import { toTitleCase } from '../helpers/textFormatter';
export const USER_ROLE = 'user';
export const ADMIN_ROLE = 'admin';
export const MANAGER_ROLE = 'manager';
export const ACCOUNTANT_ROLE = 'accountant';
export const USER_PROFILE_ROLE_VALUES = [USER_ROLE, ADMIN_ROLE, MANAGER_ROLE, ACCOUNTANT_ROLE];
const USER_PROFILE_ROLE_TO_LABEL_MAPPING = {
    [USER_ROLE]: 'Member',
    [ADMIN_ROLE]: toTitleCase(ADMIN_ROLE),
    [MANAGER_ROLE]: toTitleCase(MANAGER_ROLE),
    [ACCOUNTANT_ROLE]: toTitleCase(ACCOUNTANT_ROLE)
};
const USER_PROFILE_ROLE_DESCRIPTION = {
    [USER_ROLE]: 'Can submit expenses and request/ access cards',
    [ADMIN_ROLE]: 'Can configure controls and policies, invite users, setup accounting sync, approve/ deny expenses, and issue cards',
    [MANAGER_ROLE]: 'Reviews and approves expenses of members on their team',
    [ACCOUNTANT_ROLE]: 'Limited administration capabilities with review & accounting sync permissions'
};
export function getUserProfileRoleName(role, whitelabelConfig) {
    return whitelabelConfig.roleNames[role] || USER_PROFILE_ROLE_TO_LABEL_MAPPING[role];
}
export function getUserProfileRoleOptions(whitelabelConfig, accountantRoleEnabled) {
    return Object.keys(USER_PROFILE_ROLE_TO_LABEL_MAPPING)
        .filter((role) => {
        // Exclude accountant role unless feature is enabled
        if (role === ACCOUNTANT_ROLE && !accountantRoleEnabled) {
            return false;
        }
        return true;
    })
        .map((role) => ({
        value: role,
        label: getUserProfileRoleName(role, whitelabelConfig),
        description: USER_PROFILE_ROLE_DESCRIPTION[role]
    }));
}
export const INVITED_STATE = 'invited';
export const ACTIVE_STATE = 'active';
export const DISABLED_STATE = 'disabled';
export const DECLINED_STATE = 'invitation_declined';
export const USER_PROFILE_STATE_VALUES = [INVITED_STATE, ACTIVE_STATE, DISABLED_STATE, DECLINED_STATE];
export const ABACUS = 'abacus';
export const LEVER = 'lever';
export const API = 'api';
export const WHITELABEL_API = 'whitelabel_api';
export const SLACK = 'slack';
export const ZENEFITS = 'zenefits';
export const INVITE = 'invite';
export const INITIAL_SIGNUP = 'initial_signup';
export const ADDITIONAL_COMPANY_SIGNUP = 'additional_company_signup';
export const INVITATION_SOURCE_VALUES = [
    ABACUS,
    LEVER,
    API,
    WHITELABEL_API,
    SLACK,
    ZENEFITS,
    INVITE,
    INITIAL_SIGNUP,
    ADDITIONAL_COMPANY_SIGNUP
];
